module.exports = __webpack_public_path__ + "static/media/china.74eb56cb.svg";